// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolPeriod } from './protocol-period';
import {
    ProtocolPeriodFromJSON,
    ProtocolPeriodFromJSONTyped,
    ProtocolPeriodToJSON,
    ProtocolPeriodToJSONTyped,
} from './protocol-period';
import type { ProtocolAssessment } from './protocol-assessment';
import {
    ProtocolAssessmentFromJSON,
    ProtocolAssessmentFromJSONTyped,
    ProtocolAssessmentToJSON,
    ProtocolAssessmentToJSONTyped,
} from './protocol-assessment';

/**
 * 
 * @export
 * @interface ProtocolPart
 */
export interface ProtocolPart {
    /**
     * 
     * @type {Array<ProtocolAssessment>}
     * @memberof ProtocolPart
     */
    assessments: Array<ProtocolAssessment>;
    /**
     * 
     * @type {string}
     * @memberof ProtocolPart
     */
    name: string;
    /**
     * 
     * @type {Array<ProtocolPeriod>}
     * @memberof ProtocolPart
     */
    periods: Array<ProtocolPeriod>;
}

/**
 * Check if a given object implements the ProtocolPart interface.
 */
export function instanceOfProtocolPart(value: object): value is ProtocolPart {
    if (!('assessments' in value) || value['assessments'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('periods' in value) || value['periods'] === undefined) return false;
    return true;
}

export function ProtocolPartFromJSON(json: any): ProtocolPart {
    return ProtocolPartFromJSONTyped(json, false);
}

export function ProtocolPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolPart {
    if (json == null) {
        return json;
    }
    return {
        
        'assessments': ((json['assessments'] as Array<any>).map(ProtocolAssessmentFromJSON)),
        'name': json['name'],
        'periods': ((json['periods'] as Array<any>).map(ProtocolPeriodFromJSON)),
    };
}

export function ProtocolPartToJSON(json: any): ProtocolPart {
    return ProtocolPartToJSONTyped(json, false);
}

export function ProtocolPartToJSONTyped(value?: ProtocolPart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assessments': ((value['assessments'] as Array<any>).map(ProtocolAssessmentToJSON)),
        'name': value['name'],
        'periods': ((value['periods'] as Array<any>).map(ProtocolPeriodToJSON)),
    };
}
